import React, { useContext } from "react"; // Import useContext
import "./Footer.css";
import { Typography, Grid, Container, Box } from "@mui/material";
import { LanguageContext } from "../../context/LanguageContext"; // Import LanguageContext

export default function Footer() {
  const { language } = useContext(LanguageContext); // Consume language context

  // English content for the footer
  const enContent = {
    issadTitle: "ISSAD",
    issadDescription:
      "To involve Educationalists, Social Workers, Economists and others in the promotion of social wellbeing, human growth, and development.",
    contactTitle: "Contact Details",
    address: (
      <>
        Sheikh Zayed Islamic Centre, P.O. Box No. 8416,
        <br />
        University of Karachi, Postal Code – 75270,
        <br />
        Karachi City, Sindh, Pakistan
      </>
    ),
    phone: "021-99261062",
    email: "issadacademia@gmail.com",
    copyright: "All rights reserved.", // Added for consistency, although not strictly in the current markup
  };

  // Urdu content for the footer (You need to provide accurate translations)
  const urContent = {
    issadTitle: "اِصاد", // ISSAD in Urdu
    issadDescription:
      "ماہرین تعلیم، سماجی کارکنوں، ماہرین اقتصادیات اور دیگر کو سماجی فلاح و بہبود، انسانی ترقی اور نمو کے فروغ میں شامل کرنا۔", // Translated description
    contactTitle: "رابطہ کی تفصیلات", // Contact Details in Urdu
    address: (
      <>
        شیخ زید اسلامک سینٹر، پوسٹ بکس نمبر 8416،
        <br />
        جامعہ کراچی، پوسٹل کوڈ – 75270،
        <br />
        کراچی شہر، سندھ، پاکستان
      </>
    ),
    phone: "021-99261062", // Phone numbers usually remain the same
    email: "issadacademia@gmail.com", // Emails usually remain the same
    copyright: "تمام حقوق محفوظ ہیں۔", // All rights reserved. in Urdu
  };

  const content = language === "en" ? enContent : urContent;

  return (
    <Box className="footer">
      <Container maxWidth="lg">
        <Grid container spacing={3} alignItems="flex-start">
          <Grid item xs={12} md={6}>
            <Typography variant="h6" className="footer-title" data-tts="true">
              {content.issadTitle}
            </Typography>
            <Typography variant="body2" className="footer-text" data-tts="true">
              {content.issadDescription}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="h6" className="footer-title" data-tts="true">
              {content.contactTitle}
            </Typography>
            <Typography variant="body2" className="footer-text" data-tts="true">
              {content.address}
            </Typography>
            <Typography variant="body2" className="footer-text" data-tts="true">
              {content.phone}
            </Typography>
            <Typography variant="body2" className="footer-text" data-tts="true">
              {content.email}
            </Typography>
          </Grid>
        </Grid>
      </Container>

      <Box className="footer-bottom">
        <Typography variant="body2" align="center" data-tts="true">
          © {`${new Date().getFullYear()} `}
          <span className="highlight">ISSAD</span> {content.copyright}
        </Typography>
      </Box>
    </Box>
  );
}
